<template>
  <ModalDialog
    ref="dialog"
    title="Update Station Maintenance Mode"
    :submitting="submitting"
    submitTitle="Update"
    :scrollable="true"
    icon="fa-tools"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="stationForm" :labelColumnSize="3">
      <NotificationBar type="warning" v-if="maintenanceData.isMaintenanceMode">
        <NotificationBarTitle>The station will be unavailable for order scheduling during maintenance mode</NotificationBarTitle>
        <ul>
          <li>If no alternative stations are available, orders requiring this station will have extended estimated dates</li>
        </ul>
      </NotificationBar>

      <FormRow label="Maintenance Mode">
        <FormCheckbox v-model="maintenanceData.isMaintenanceMode" field="isMaintenanceMode" />
      </FormRow>

      <FormRow label="Estimated End Date" v-if="maintenanceData.isMaintenanceMode" helpTip="This date is used to calculate order estimates">
        <FormDate v-model="maintenanceData.dateEstimatedMaintenanceEnd" field="dateEstimatedMaintenanceEnd" note="Date when the maintenance is estimated to be completed" />
      </FormRow>
      
      <FormRow label="Update Notes">
        <FormInputTextArea  v-model="maintenanceData.notes" placeholder="Enter details for maintenance" field="notes" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'ProductionStationMaintenanceDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    productionStationId: Number
  },
  data() {
    return {
      maintenanceData: {
        isMaintenanceMode: false,
        dateEstimatedMaintenanceEnd: moment().local().add(1, 'days').toISOString(),
        notes: ''
      },
      stationForm: {},
      submitting: false,
    }
  },
  created() {
  },
  mounted() {
    
  },
  computed: {
  },
  methods: {
    show(productionStation) {
      this.maintenanceData.isMaintenanceMode = productionStation.isMaintenanceMode
      
      if(productionStation.dateEstimatedMaintenanceEnd && this.maintenanceData.isMaintenanceMode)
        this.maintenanceData.dateEstimatedMaintenanceEnd = moment(productionStation.dateEstimatedMaintenanceEnd).toDate().toISOString()
    
      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = {
        isMaintenanceMode: this.maintenanceData.isMaintenanceMode,
        notes: this.maintenanceData.notes
      }
      if(this.maintenanceData.isMaintenanceMode)
        updateData.dateEstimatedMaintenanceEnd = moment(this.maintenanceData.dateEstimatedMaintenanceEnd).toDate().toISOString()

      this.$apiService.productionService.updateProductionStationMaintenance(this.productionStationId, updateData)
      .then(response => {
        this.submitting = false
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.submitting = false
        this.$data.stationForm = this.processFormResponse(err)
      })
    }
  }
}
</script>